var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "field field--thin field--standalone",
      class: {
        "field--error": _vm.errors.length && _vm.errors[0].type === "error",
      },
    },
    [
      _vm._text
        ? _c("span", { staticClass: "field__label" }, [
            _vm._v("\n    " + _vm._s(_vm._text) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }